module.exports = __webpack_public_path__ + "img/priorityicon.d08c3915.svg";